<template>
  <v-card
    v-if="!$apollo.loading && me"
    class="mb-5"
  >
    <v-flex>
      <v-card-title>{{ $t('security.twofa') }}</v-card-title>
      <p>
        {{ $t('security.twofaDesc') }}
      </p>
      <v-divider class="mb-5" />
      <p>
        <small>
          {{ $t('security.status') }}: 
        </small>&nbsp;
        <v-chip
          pill
          small
          :color="me.twofa ? 'success' : ''"
        >
          <b>{{ me.twofa ? $t('security.active') : $t('security.notActive') }}</b>
        </v-chip>
      </p>
      
      <p v-if="me.twofa">
        <small>
          {{ $t('security.method') }}: 
          <b>{{ me.twofa_method ? $t('security.'+me.twofa_method) : $t('security.notSpecified') }}</b>
        </small>
      </p>
    </v-flex>
    <v-flex
      d-flex
      justify-end
    >
      <v-btn
        text
        outlined
        small
        @click="!me.twofa ? twofaDialog = true : deactivateTwofaDialog = true"
      >
        {{ !me.twofa ? $t('security.activate') : $t('security.deactivate') }}
      </v-btn>
    </v-flex>
    <two-fa-dialog
      v-if="twofaDialog"
      :show-dialog="twofaDialog"
      @closeTwoFaDialog="closeTwoFaDialog"
    />
    <deactivate-two-fa-dialog
      v-if="deactivateTwofaDialog"
      :show-dialog="deactivateTwofaDialog"
      :twofa-method="me.twofa_method"
      @closeDeactivateTwoFaDialog="closeDeactivateTwoFaDialog"
    />
  </v-card>
</template>

<script>

import TwoFaDialog from "@/views/Security/partial/TwoFaDialog.vue";
import DeactivateTwoFaDialog from "@/views/Security/partial/DeactivateTwoFaDialog.vue";

export default {
  name: "TwoFaView",
  components: {
    TwoFaDialog,
    DeactivateTwoFaDialog
  },
  data() {
    return {
      twofaDialog: false,
      deactivateTwofaDialog: false,
      loading: false
    };
  },
  methods: {
    closeTwoFaDialog(val) {
      this.twofaDialog = val
      this.$apollo.queries.me.refetch();
    },
    closeDeactivateTwoFaDialog(val) {
      this.deactivateTwofaDialog = val
      this.$apollo.queries.me.refetch();
    }
  },
  apollo: {
    me: {
      query: require("@/graphql/queries/Me.gql")
    }
  }
};
</script>



<style lang="scss" >
@import "@/styles/material-dashboard/_colors.scss";

.dashboard {
  .v-card__title {
    margin-bottom: 15px;
  }
  .v-card__text {
    padding: 3px;
    .v-avatar {
      border-radius: 50% !important;
      margin-top: -2px;
      .v-icon {
        color: $grey-100;
      }
    }
    span {
      font-weight: 400;
      font-size: 20px;
      margin: 10px;
      color: $black;
    }
  }
}
</style>
